"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var deepmerge_1 = __importDefault(require("deepmerge"));
var theme_1 = __importDefault(require("./Checkbox/theme"));
exports.formTheme = function (theme) {
    var componentTheme = {
        borderColor: {
            checked: theme.base.color.text,
            error: theme.error.color.normal,
            active: theme.primary.color.normal,
            disabled: theme.greyDark.color.normal,
            normal: theme.greyNormal.color.normal,
        },
        backgroundColor: {
            checked: theme.greyDark.color.normal,
            error: theme.base.color.normal,
            normal: theme.base.color.normal,
            disabled: theme.greyNormal.color.normal,
        },
        borderRadius: theme.global.borderRadius,
        boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.15)',
        fontSize: {
            large: '1rem',
            medium: '.875rem',
            small: '.813rem',
        },
        textColor: {
            normal: theme.base.color.text,
            error: theme.error.color.normal,
            disabled: theme.greyDark.color.normal,
            placeholder: theme.greyLight.color.normal,
        },
        input: {
            padding: '0.75rem 1.25rem',
        },
        checkbox: theme_1.default(theme),
        checkboxGroup: {
            label: 'rgba(38, 39, 41, 0.5)',
        },
        radio: {
            width: '1rem',
            height: '1rem',
            color: theme.greyNormal.color.text,
            focus: {
                color: theme.greyNormal.color.text,
            },
            disabled: {
                backgroundColor: theme.greyLight.color.normal,
                color: theme.greyNormal.color.normal,
            },
        },
        radioGroup: {
            label: 'rgba(38, 39, 41, 0.5)',
        },
        label: {
            margin: '.25rem',
            padding: '.25rem',
            disabledInline: {
                color: 'rgba(38, 39, 41, 0.5)',
            },
        },
        lengthCheck: {
            validColor: theme.success.color.normal,
            color: theme.greyDark.color.normal,
        },
        select: {
            default: {
                padding: '0.1875rem 0.5rem 0.125rem',
            },
            option: {
                padding: '0.5rem 1.25rem',
                margin: '0.5rem 0',
            },
        },
        textarea: {
            padding: '0.75rem 1.25rem',
        },
        error: {
            margin: '.125rem',
        },
        password: {
            buttoncolor: theme.greyDark.color.normal,
        },
        passwordStrength: {
            text: {
                invalid: theme.error.color.normal,
                weak: theme.error.color.normal,
                medium: theme.warning.color.normal,
                strong: theme.success.color.normal,
            },
            indicator: {
                default: theme.greyDark.color.normal,
                weak: theme.error.color.normal,
                medium: theme.warning.color.normal,
                strong: theme.success.color.normal,
            },
        },
    };
    if (theme.component.form) {
        componentTheme = deepmerge_1.default(componentTheme, theme.component.form);
    }
    return __assign(__assign({}, theme), { component: __assign(__assign({}, theme.component), { form: componentTheme }) });
};
exports.default = exports.formTheme;
//# sourceMappingURL=theme.js.map